module.exports = __webpack_public_path__ + "3a2c710f09fd8e09b5000c50fe0a0b08.svg";